import React from 'react';

export default function NoResults()
{
    return (
        <div className='ajax_error'>
            <h3>No questions matching your search criteria</h3>
        </div>
    );
};